module.exports = "<div class=calendar-export> <div class=input-date> <div class=\"start date flex\"> <span>开始时间：</span> <div class=\"start-date export-date-picker\"></div> </div> <div class=\"end date flex\"> <span>结束时间：</span> <div class=\"end-date export-date-picker\"></div> </div> </div> <button class=export-btn>导出</button> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendar.main/calendar.export/calendar.export.html
// module id = 4954
// module chunks = 50